import { mdiArrowRight, mdiTag } from '@mdi/js';
import Icon from '@mdi/react';
import get from 'lodash/get';
import Lottie from 'lottie-react';
import moment from 'moment';
import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { PROFIT_PAGES } from '../../../../../constants';
import ListHeaderTitle from '../../../../atoms/list-header-title';
import TitleWithDivider from '../../../../molecules/titles/with-divider';
import SubscribeModal from '../../subscribe/subscribeModal';
import SubscriptionCardShimmer from '../subscription-card-shimmer';
import SubscriptionPlans from '../subscription-plans';
import SubscriberIcon from './card-lottie.json';
import Typewriter from './typeWritter';
import { isMobileOnly as isMobile } from 'react-device-detect';
import './hard-paywall-card.m.css';

const HardPaywallCard = ({ features, churnUser, plans = [], isSubscriber }) => {
  const [isLoading, setLoading] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [activeSubscription, setActiveSubscription] = useState(null);
  const userSubscription = useSelector((state) =>
    get(state, ['userData', 'userSubscription'], null),
  );
  const typeWriterArray = ['Smarter', 'Strategic', 'Informed'];

  return (
    <>
      <div id="hardpaywall" styleName="story-subscribe-wrap">
        <img
          src="/images/story_top_img.svg"
          styleName="top-banner"
          style={{
            display: features?.independence_day?.active ? 'none' : 'block',
          }}
        />
        {!isLoading && (
          <div styleName="banner-img">
            <img
              src={`${
                isMobile
                  ? 'https://quintype-dropbox.s3-accelerate.amazonaws.com/bqprimehindi.quintype.com/2024-08-07/5itzmq0x/freedom_sale_banner.png'
                  : 'https://quintype-dropbox.s3-accelerate.amazonaws.com/bqprimehindi.quintype.com/2024-08-07/389mes2x/freedom_sale_banner_desk.png'
              }`}
              style={{
                display: features?.independence_day?.active && !isSubscriber ? 'block' : 'none',
                width: '100%',
              }}
            />
          </div>
        )}

        {isLoading ? (
          <SubscriptionCardShimmer churnUser={churnUser} />
        ) : (
          <>
            {isSubscriber === false || isSubscriber === null ? (
              <div
                styleName="hardpaywall-wrap"
                style={{
                  marginTop: features?.independence_day?.active
                    ? isMobile
                      ? '-15px'
                      : '-70px'
                    : '0px',
                }}
              >
                <div styleName="top-section">
                  {churnUser ? (
                    <>
                      <div styleName="offer-label">
                        <Icon path={mdiTag} size="14px" />
                        SPECIAL OFFER
                      </div>
                      <div styleName="title churn-title">
                        More Value&nbsp;
                        <span styleName="typewritter-text">Same Price</span>
                      </div>
                      <div styleName="desc-text">
                        Unlock{' '}
                        <span>
                          Extra Months
                          <img src="/images/underline.svg" styleName="underline" />
                        </span>{' '}
                        On Your Subscription
                      </div>
                    </>
                  ) : (
                    <>
                      <div styleName="title">
                        Make&nbsp;
                        <span styleName="typewritter-text">
                          <Typewriter text={typeWriterArray} />
                        </span>
                      </div>
                      <span styleName="title">Business Decisions</span>
                      <div styleName="desc-text">
                        with NDTV Profit’s<span> Unlimited Access Subscription</span>
                      </div>
                    </>
                  )}
                </div>
                <div styleName="subscription-wrap">
                  <div styleName="title-wrapper">
                    <TitleWithDivider>
                      <ListHeaderTitle title="Choose a plan" />
                    </TitleWithDivider>
                    <SubscriptionPlans
                      setLoading={setLoading}
                      setActiveSubscription={setActiveSubscription}
                      setOpen={setOpen}
                      churnUser={churnUser}
                      defaultPlans={plans}
                    />
                  </div>
                </div>
              </div>
            ) : isSubscriber === true ? (
              <div styleName="hardpaywall-wrap">
                <div styleName="non-subscriber-wrap">
                  <Lottie animationData={SubscriberIcon} loop={true} autoplay={true} />
                  <h1 styleName="heading">You are already </h1>
                  <h1 styleName="subscriber-text">
                    a <span>Subscriber</span>
                  </h1>
                  <div styleName="exp-text">Subscription Expires on </div>
                  <div styleName="exp-date">
                    {userSubscription?.active &&
                      moment(userSubscription?.active?.end_timestamp).format('MMMM DD, YYYY')}
                  </div>
                  <div styleName="divider">
                    <div styleName="line"></div>
                    <div styleName="text">YOU HAVE ACCESS TO</div>
                    <div styleName="line"></div>
                  </div>
                  <div styleName="menu-btn">
                    {PROFIT_PAGES?.map((list, index) => (
                      <a href={list.link} styleName="btn" key={index}>
                        {list.name}
                      </a>
                    ))}
                  </div>
                  <a href="/" styleName="back-btn">
                    Back to Homepage <Icon path={mdiArrowRight} size={'18px'} />
                  </a>
                </div>
              </div>
            ) : null}
          </>
        )}
        <img src="/images/story_bottom_img.svg" styleName="bottom-banner" />
      </div>
      {isOpen && (
        <SubscribeModal isOpen={isOpen} setOpen={setOpen} subscription={activeSubscription} />
      )}
    </>
  );
};

HardPaywallCard.propTypes = {};
HardPaywallCard.defaultProps = {};

const mapStateToProps = (state) => ({
  features: get(state, ['qt', 'config', 'features'], {}),
  isSubscriber: get(state, ['userData', 'isSubscriber'], null)
});

export default connect(mapStateToProps)(HardPaywallCard);
